const formName = 'form-save-report';

export default formName;
